import {API, axios} from '@/api'
import {getCorrectUrlParamsFormat} from '../../utilities/helper';
import enrollments from './enrollments';
import { AxiosError } from 'axios';


export default {
  async getPackets(params: any) {
    try {
      const url = API.getPackets() + '?' + getCorrectUrlParamsFormat(params) ;
      const response = await axios.get(url)
      return response.data.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error fetching packets:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async getPacket(id) {
    try {
      const response = await axios.get(API.getPacket(id));
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error fetching packet:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async createPacket(packet) {
    try {
      const response = await axios.post(API.createPacket(), packet)
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error creating packet:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async updatePacket(packet) {
    try {
      const response = await axios.put(API.updatePacket(packet.id), packet)
      return response.data
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error updating packet:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },
  
  async archivePacket(id) {
    try {
      const response = await axios.delete(API.archivePacket(id));
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error archiving packet:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

async addAgenciesToPacket(id,obj) {
  try {
    
    const response = await axios.put(API.addAgenciesToPacket(id),obj);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error adding agencies to packet:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
},

async getAgenciesByPacketId(id,params) {
  try {
    const url  = API.getAgenciesByPacketId(id) + '?' + getCorrectUrlParamsFormat(params)
    const response = await axios.get(url, { headers: enrollments.getAuthHeaders() });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error fetching agencies by packet ID:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
},

async deleteAgencyFromPacket(id) {
  try {
    const response = await axios.delete(API.deleteAgencyFromPacket(id));
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error deleting agency from packet:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
} ,

async setDefaultPacket(id,obj) {
  try {
    const response = await axios.put(API.setDefaultPacket(id),obj);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error setting default packet:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
},

async updateDocumentOrder(obj) {
  try {
    const response = await axios.put(API.updateDocumentOrder(), obj);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error updating document order:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
},

async deleteDocumentFromPacket(id, obj) {
  try {
    const response = await axios.delete(API.deleteDocumentFromPacket(id), obj);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error deleting document from packet:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
},

async assignDocumentToPacket(id, obj) {
  try {
    const response = await axios.put(API.assignDocumentToPacket(id), obj);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error assigning document to packet:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
},

async deletePacket(id) {
  try {
    const response = await axios.delete(API.deletePacket(id));
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error deleting packet:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
    throw error;
  }
}
}
